import { Browser } from '@capacitor/browser';
export default () => {
  const openUrl = async (url) => {
    if (!url) {
      return;
    }

    // Browser.open needs an absolute http(s) URL; the API may return a path.
    const absoluteUrl = new URL(url, process.env.VUE_APP_URL).href;

    try {
      await Browser.open({ url: absoluteUrl });
    } catch (error) {
      // Fall back to the system browser when the in-app browser can't open.
      console.error('Browser.open failed', error);
      window.open(absoluteUrl, '_system');
    }
  };

  return { openUrl };
};
